export default __webpack_public_path__ + "static/media/Limitation_Yoga.4f5b09de.svg";